<!--
 * @Description: 学习时长统计
 * @Author: xiawenlong
 * @Date: 2021-04-22 19:45:20
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-04-23 11:49:14
-->
<template>
  <div class="card study chart">
    <div class="header">
      <div class="title">销售数据</div>
      <div class="filter">
        <ul>
          <li
            v-for="item in periods"
            :key="item.value"
            :class="{ active: activePeriod === item.value }"
            @click="handlePeriodChange(item.value)"
          >
            {{ item.label }}
          </li>
        </ul>
        <el-date-picker
          v-model="date"
          size="mini"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          disabled
        >
        </el-date-picker>
      </div>
    </div>
    <div id="salesDataCharts" class="chart"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import { GridComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([GridComponent, TitleComponent, TooltipComponent, BarChart, CanvasRenderer])

export default {
  name: 'StudyCard',
  props: {
    dataTrendList: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activePeriod: 'WEEK',
      periods: [
        { label: '本周', value: 'WEEK' },
        { label: '本月', value: 'MONTH' },
        { label: '全年', value: 'YEAR' },
      ],
      date: [],
      startTime: '',
      endTime: '',
      chartInstance: null,
    }
  },
  watch: {
    dataTrendList: {
      handler(newVal) {
        if (newVal && newVal.timeList && newVal.amountList) {
          this.updateChart()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.handlePeriodChange(this.activePeriod)
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    initChart() {
      const dom = document.getElementById('salesDataCharts')
      if (!dom) return
      this.chartInstance = echarts.init(dom)
      this.updateChart()
    },
    updateChart() {
      if (!this.chartInstance) return
      const { timeList = [], amountList = [] } = this.dataTrendList || {}
      const option = {
        title: {
          // text: '销量趋势',
          subtext: '单位：元',
          left: 10,
          top: 0,
          textStyle: {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333333',
          },
          subtextStyle: {
            fontSize: 12,
            color: '#999999',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 50,
          right: 20,
          top: 50,
          bottom: 30,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: {
            lineStyle: {
              color: '#e2e2e2',
            },
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#f0f0f0',
              type: 'dashed',
            },
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12,
          },
        },
        series: [
          {
            type: 'bar',
            data: amountList,
            barWidth: '50%',
            itemStyle: {
              color: '#4B8CFF',
              borderRadius: [2, 2, 0, 0],
            },
          },
        ],
      }
      this.chartInstance.setOption(option)
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    handlePeriodChange(period) {
      this.activePeriod = period
      const now = new Date()
      let start, end
      if (period === 'WEEK') {
        const day = now.getDay() || 7
        start = new Date(now)
        start.setFullYear(now.getFullYear(), now.getMonth(), now.getDate() - day + 1)
        end = new Date(start)
        end.setFullYear(start.getFullYear(), start.getMonth(), start.getDate() + 6)
      } else if (period === 'MONTH') {
        start = new Date(now.getFullYear(), now.getMonth(), 1)
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      } else if (period === 'YEAR') {
        start = new Date(now.getFullYear(), 0, 1)
        end = new Date(now.getFullYear(), 11, 31)
      }
      this.startTime = this.formatDate(start)
      this.endTime = this.formatDate(end)
      this.date = [this.startTime, this.endTime]
      this.$emit('change', {
        activePeriod: this.activePeriod,
        startTime: this.startTime,
        endTime: this.endTime,
      })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  &.chart {
    width: calc(100% - 483px);
    height: 307px;
    .chart {
      width: 100%;
      height: 260px;
    }
    .header {
      .filter {
        display: flex;
        align-items: center;
        ul {
          display: flex;
          li {
            cursor: pointer;
            width: 30px;
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            margin-right: 20px;
            &.active {
              color: #ff7b33;
            }
          }
        }
        .el-date-editor {
          width: 250px;
        }
      }
    }
  }
}
</style>
